module.exports = __webpack_public_path__ + "img/tutorial_books_03.33c82876.gif";